import { render, staticRenderFns } from "./Free_shippings.vue?vue&type=template&id=69caf7a1&scoped=true&"
import script from "./Free_shippings.vue?vue&type=script&lang=js&"
export * from "./Free_shippings.vue?vue&type=script&lang=js&"
import style0 from "./Free_shippings.vue?vue&type=style&index=0&id=69caf7a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69caf7a1",
  null
  
)

export default component.exports